module.exports = __webpack_public_path__ + "img/pic_01_sel.79fed50c.png";